'use client';

import { useTranslations } from 'next-intl';

import { Icon } from '@workspace/lib/components/atoms/icons/Icon';
import type { BasicButtonProps } from '@workspace/lib/types/form-handlers';
import { cn } from '@workspace/lib/utils/cn';

interface PrimaryButtonProps extends BasicButtonProps {
  /** Icon name to display before the text */
  iconName?: string;
}

const PrimaryButton = ({
  type,
  disabled,
  className,
  textContent,
  onClick,
  iconName,
  additionalMessage,
}: PrimaryButtonProps) => {
  const t = useTranslations();

  return (
    <>
      <button
        type={type}
        disabled={disabled}
        aria-disabled={disabled}
        onClick={onClick}
        className={cn(
          'w-full rounded-full md:max-w-xs',
          'flex items-center justify-center gap-2',
          'font-branding py-[11px] text-lg font-semibold',
          'bg-blue-primary text-white-primary',
          'hover:bg-dark-blue-130',
          'transition-all duration-200',
          'not-disabled:cursor-pointer',
          'disabled:bg-neutral-500 disabled:text-neutral-800',
          className,
        )}
      >
        {iconName && <Icon as='span' iconKey={iconName} />}
        {textContent ? (t.has(textContent) ? t(textContent) : textContent) : ''}
      </button>
      {additionalMessage?.placement === 'below' && (
        <p className='font-branding text-sm font-semibold text-neutral-600'>
          {additionalMessage.message}
        </p>
      )}
    </>
  );
};

export default PrimaryButton;
